export const state = {
  threshold_old_tabledata: null,
};

export const getters = {
};

export const mutations = {
  set_threshold_old_tabledata(state, threshold_old_tabledata) {
      state.threshold_old_tabledata = threshold_old_tabledata
  }
};

